class EventTemplate {
	constructor(el) {
		this.el = el;
		this.featuredEventEl = this.el.querySelector('.event__featured-event');
		this.featuredEventRow = this.el.querySelector('.event__featured-event-row');
		this.featuredId = this.featuredEventRow.dataset.featuredId;
		this.baseUrl = window.location.origin;
		
		this.displayFeatured();
		this.displaySearchIcon();
		
	}

	displaySearchIcon () {
		const almSearch = document.getElementsByClassName('search-icon');
		const almSearchButton = almSearch[0].getElementsByTagName('button');
		almSearchButton[0].innerHTML = '<i class="fas fa-search"></i>';
	}
	
	

	displayFeatured = () => {
		window.almComplete = () => {
			const ajaxLoadMoreListing = document.querySelector('.alm-listing');
			const almFilters = ajaxLoadMoreListing.querySelector('.alm-filters');
			const cards = ajaxLoadMoreListing.querySelectorAll('.card');

			if (almFilters.dataset.url === this.baseUrl + '/event/') {
				this.featuredEventRow.classList.remove('hidden');
			} else {
				this.featuredEventRow.classList.add('hidden');
			}
			
			cards.forEach((card) => {
				if (card.dataset.postId === this.featuredId && almFilters.dataset.url === this.baseUrl + '/event/') {
					card.classList.add('hidden');
				}
			});
		};
	}

	
}

export default EventTemplate;
